import {
    EntityCommandCreateResponse,
    RevisionedCommandResponse,
    StudyEntityType,
    TitleContent,
    toTitleContent,
} from '@faro/study-designer-model';
import axios from 'axios';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { StudyPathParameter } from '../parameter';

const factory = createStudyEntityHookFactory<TitleContent>(StudyEntityType.TitleContent);

export const useTitleContents = factory.list(
    (
        { studyId, ...query }: StudyPathParameter & { revision?: number },
        signal?: AbortSignal
    ): Promise<TitleContent[]> => {
        return axios
            .get(`/api/study-designer/studies/${studyId}/title-content`, {
                signal,
                params: query,
            })
            .then(response => response.data?.map(toTitleContent) ?? []);
    }
);

export const useTitleContentInsert = factory.mutate(
    (entity: Partial<TitleContent>): Promise<RevisionedCommandResponse<EntityCommandCreateResponse>> => {
        const { studyId, ...titleContent } = entity;
        return axios
            .post(`/api/study-designer/studies/${studyId}/title-content`, titleContent)
            .then(response => response.data);
    }
);

export const useTitleContentUpdate = factory.mutate(
    (entity: TitleContent) => {
        return axios
            .put(`/api/study-designer/studies/${entity.studyId}/title-content/${entity.id}`, entity)
            .then(response => response.data);
    },
    {
        optimisticUpdate: (titleContent, optimisticData) => {
            return optimisticData.map(x => (x.id === titleContent.id ? titleContent : x));
        },
    }
);
